export default __webpack_public_path__ + "static/media/img-vitrine.685d390f.jpg";